<button mat-button color="primary" (click)="back()">
   <mat-icon>arrow_back</mat-icon>
   Back
</button>
<ng-container *ngIf="task">
   <div [froalaEditor]="options" id="pdf-source">
      <app-report-header
         *ngIf="orgName"
         [orgName]="orgName"
         [logo]="logo"
         category="Task Overview"
         [title]="task?.name"
         subtitle="{{ businessUnit?.name }} &#8250; {{ department?.name }} &#8250; {{
            deptFn?.name
         }}"
      ></app-report-header>
      <div
         style="
            display: flex;
            flex-direction: column;
            border-bottom: 2px solid black;
            margin-bottom: 8px;
            padding-bottom: 8px;
         "
      >
         <div>
            <div style="font-size: 12pt; font-weight: bold; color: #757575">Purpose</div>
            <app-report-text [text]="task.purpose"></app-report-text>
         </div>
         <div>
            <div style="font-size: 12pt; font-weight: bold; color: #757575">Policies</div>
            <app-report-text [text]="task.policies"></app-report-text>
         </div>
         <div>
            <div style="font-size: 12pt; font-weight: bold; color: #757575">KPI</div>
            <app-report-text [text]="task.kpi"></app-report-text>
         </div>
         <div>
            <div style="font-size: 12pt; font-weight: bold; color: #757575">Benchmark</div>
            <app-report-text [text]="task.benchmark"></app-report-text>
         </div>
         <div>
            <div style="font-size: 12pt; font-weight: bold; color: #757575">Competencies</div>
            <app-report-text [text]="task.competencies"></app-report-text>
         </div>
      </div>
      <h5>Steps</h5>
      <ng-container *ngFor="let step of task.steps">
         <div style="font-size: 12pt; font-weight: bold">{{ step.order + 1 }}: {{ step.name }}</div>
         <div style="margin-left: 16px">
            <app-report-text [text]="step.instructions"></app-report-text>
         </div>
      </ng-container>
   </div>
</ng-container>
